<div class="bg-white h-100">
  <era-master-detail flexGrowLeft="1"
                     flexGrowRight="2">
    <era-master>
      <era-panel>
        @if ((apps | async) === null || (apps | async) === undefined) {
          <ml-sk-spinner-3></ml-sk-spinner-3>
        } @else if (apps | async; as apps) {
          @if (apps?.length > 0) {
            <div class="list-group list-group-flush border-bottom">
              @for (a of apps; track a) {
                <a class="list-group-item list-group-item-action"
                   [routerLink]="[a.identifier]"
                   routerLinkActive="active">
                  {{ a.name }}
                </a>
              }
            </div>
          } @else {
            <div class="d-flex h-100 w-100 align-items-center justify-content-center">
              <div class="text-center text-muted p-4">
                <p>No applications have been installed on this device yet.</p>
                <small>Please refresh to retrieve the latest apps from the device.</small>
              </div>
            </div>
          }
        }
        <era-panel-footer>
          <div class="btn-toolbar p-1 bg-gray-100 border-top">
            @if (udid | async; as udid) {
              <button type="button"
                      class="btn btn-outline-primary border-0"
                      (click)="showInstallApplicationModal(udid)">
                <fa-icon icon="plus"></fa-icon>
              </button>
            }
            <ml-mdm-command-spinner [commandProgress]="refreshAppsProgress"
                                    [small]="true"
                                    [direction]="'right'"
                                    [reverse]="true"
                                    class="flex-grow-1 text-end">
              @if (udid | async; as udid) {
                <button type="button"
                        (click)="refresh(udid)"
                        class="btn btn-outline-primary border-0"
                        data-testid="refresh-apps-button">
                  <fa-icon icon="sync"></fa-icon>
                </button>
              }
            </ml-mdm-command-spinner>
          </div>
        </era-panel-footer>
      </era-panel>
    </era-master>
  </era-master-detail>
</div>